import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const LossLedgerPage = lazy(() => import("@/features/dashboard/pages/loss-ledger"));

export const Route = createFileRoute("/(app)/dashboard/loss-ledger")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <LossLedgerPage />
    </Suspense>
  ),
});
